import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type InstantRoomBlockGuestViewQueryVariables = Types.Exact<{
  instantRoomBlockId: Types.Scalars['ID'];
}>;

export type InstantRoomBlockGuestViewQuery = {
  __typename?: 'Query';
  instantRoomBlockGuestView?: {
    __typename?: 'InstantRoomBlockGuestView';
    id: string;
    hostFirstName: string;
    hotelName?: string | null;
    joyPlaceId: string;
    checkInDate: string;
    checkOutDate: string;
    nights: number;
    roomTypeName?: string | null;
    adults?: number | null;
    roomFacilities: Array<string>;
    roomPhotoUrls: Array<string>;
    freeCancellationUntil?: string | null;
    availableRoomCount: number;
    bookByDate: string;
    isClaimable: boolean;
    joyPlace?: {
      __typename?: 'JoyPlace';
      id: string;
      address?: string | null;
      city?: string | null;
      state?: string | null;
      starRating?: number | null;
      lat?: number | null;
      long?: number | null;
      photo?: { __typename?: 'Photo'; id: string; url: string } | null;
      userRating?: { __typename?: 'UserRating'; ratingValue?: number | null; ratingCount?: number | null } | null;
    } | null;
    nightlyRate: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode };
    originalNightlyRate?: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode } | null;
    totalRate: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode };
    originalTotalRate?: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode } | null;
    taxesAndFees: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode };
    totalWithTaxes: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode };
    onsiteCharges: Array<{
      __typename?: 'TravelOfferReservationOnsiteCharge';
      title: string;
      units?: Array<string> | null;
      unitPrice: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
    }>;
    onsiteChargesTotal?: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number } | null;
    policies: Array<{ __typename?: 'OfferPolicy'; title?: string | null; description?: string | null }>;
    cancellationPolicies: Array<{
      __typename?: 'TravelOfferReservationCancellationPolicyRule';
      start: string;
      end?: string | null;
      estimatedCancellationAmount?: {
        __typename?: 'TravelOfferReservationEstimatedCancellationAmount';
        amount: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
      } | null;
      estimatedFeeAmount?: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number } | null;
    }>;
    roomTypes: Array<{
      __typename?: 'InstantRoomBlockGuestRoomType';
      roomTypeKey: Types.InstantRoomBlockRoomTypeKeyDtoEnum;
      roomTypeName?: string | null;
      bedsDescription?: string | null;
      maxGuests?: number | null;
      adults?: number | null;
      availableRoomCount: number;
      roomFacilities: Array<string>;
      roomPhotoUrls: Array<string>;
      freeCancellationUntil?: string | null;
      nightlyRate: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode };
      originalNightlyRate?: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode } | null;
      totalRate: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode };
      originalTotalRate?: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode } | null;
      taxesAndFees: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode };
      totalWithTaxes: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode };
      onsiteCharges: Array<{
        __typename?: 'TravelOfferReservationOnsiteCharge';
        title: string;
        units?: Array<string> | null;
        unitPrice: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
      }>;
      onsiteChargesTotal?: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number } | null;
      policies: Array<{ __typename?: 'OfferPolicy'; title?: string | null; description?: string | null }>;
      cancellationPolicies: Array<{
        __typename?: 'TravelOfferReservationCancellationPolicyRule';
        start: string;
        end?: string | null;
        estimatedCancellationAmount?: {
          __typename?: 'TravelOfferReservationEstimatedCancellationAmount';
          amount: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
        } | null;
        estimatedFeeAmount?: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number } | null;
      }>;
    }>;
  } | null;
};

export const InstantRoomBlockGuestViewDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InstantRoomBlockGuestView' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instantRoomBlockId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instantRoomBlockGuestView' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'instantRoomBlockId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'instantRoomBlockId' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hostFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hotelName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'joyPlace' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userRating' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'ratingValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ratingCount' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'long' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nights' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roomTypeName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adults' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roomFacilities' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roomPhotoUrls' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nightlyRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalNightlyRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalTotalRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taxesAndFees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalWithTaxes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'freeCancellationUntil' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onsiteCharges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unitPrice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'units' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onsiteChargesTotal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'policies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cancellationPolicies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimatedCancellationAmount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimatedFeeAmount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'availableRoomCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'roomTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'roomTypeKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roomTypeName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bedsDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxGuests' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adults' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'availableRoomCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roomFacilities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roomPhotoUrls' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nightlyRate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'originalNightlyRate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalRate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'originalTotalRate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'taxesAndFees' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalWithTaxes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'freeCancellationUntil' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onsiteCharges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'unitPrice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'units' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onsiteChargesTotal' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'policies' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicies' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'estimatedCancellationAmount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'estimatedFeeAmount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'bookByDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isClaimable' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useInstantRoomBlockGuestViewQuery__
 *
 * To run a query within a React component, call `useInstantRoomBlockGuestViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstantRoomBlockGuestViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstantRoomBlockGuestViewQuery({
 *   variables: {
 *      instantRoomBlockId: // value for 'instantRoomBlockId'
 *   },
 * });
 */
export function useInstantRoomBlockGuestViewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InstantRoomBlockGuestViewQuery, InstantRoomBlockGuestViewQueryVariables>) {
  return ApolloReactHooks.useQuery<InstantRoomBlockGuestViewQuery, InstantRoomBlockGuestViewQueryVariables>(InstantRoomBlockGuestViewDocument, baseOptions);
}
export function useInstantRoomBlockGuestViewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InstantRoomBlockGuestViewQuery, InstantRoomBlockGuestViewQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<InstantRoomBlockGuestViewQuery, InstantRoomBlockGuestViewQueryVariables>(InstantRoomBlockGuestViewDocument, baseOptions);
}
export type InstantRoomBlockGuestViewQueryHookResult = ReturnType<typeof useInstantRoomBlockGuestViewQuery>;
export type InstantRoomBlockGuestViewLazyQueryHookResult = ReturnType<typeof useInstantRoomBlockGuestViewLazyQuery>;
export type InstantRoomBlockGuestViewQueryResult = Apollo.QueryResult<InstantRoomBlockGuestViewQuery, InstantRoomBlockGuestViewQueryVariables>;
